import { useState, useEffect, useContext } from "react";
import useUtilities from "./useutilities";
import { UtilitiesValue } from "../contexts/utilities";

export default function useUtilitySources() {
  const { utilities: _utilities } = useContext(UtilitiesValue);
  const utilities = useUtilities();
  const [sources, setSources] = useState([]);

  useEffect(() => {
    const sources = _utilities.map((utility) => {
      const schema = utilities.find((x) => x.name === utility.name);
      if (!schema) {
        return;
      }
      const fields = schema.returning
        .filter((x) => x.kind === "data")
        .map((x) => {
          let returnType = { ...utility.props };
          x.type.split(".").forEach((x) => {
            try {
              returnType = returnType[x];
            } catch (err) {
              returnType = null;
            }
          });
          const getReturnList = (list) => {
            try {
              let returnList = { ...utility.props };
              x.list.split(".").forEach((x) => {
                returnList = returnList[x];
              });
              return returnList;
            } catch (err) {
              return list;
            }
          };
          return {
            returnType: returnType ? returnType : x.type,
            returnList: getReturnList(x.list),
            name: x.displayName,
            code: x.name,
            params: x.props || [],
            category: "Values",
          };
        });
      return {
        name: utility.displayName,
        code: utility.id,
        fields: fields,
        kind: "utility",
        params: [],
        category: "Utilities",
        returnType: null,
        returnList: null,
      };
    });
    setSources(sources.filter((x) => !!x));
  }, [_utilities, utilities]);
  return sources;
}
